import {PAGE_IDS} from '../Constants';

const Application = {
  ORG: 'flighttraveltrip',
  ORG_DISPLAY_NAME: 'Flight Travel Trip',
  ORG_ADD_LINE1: 'Plot No 14, First Floor, Electronic City, Sector 18,',
  ORG_ADD_LINE2: 'Gurugram, Haryana, 122015, India',
  STORAGE_HOST: 'https://storage.googleapis.com',
  PRODUCTION_API_BASE_URL: 'https://myfaresinfo.com/alpha',
  LOCAL_API_BASE_URL: 'https://myfaresinfo.com/alpha',
  //LOCAL_API_BASE_URL: 'http://localhost:8080/alpha',
  STORAGE_URL_STATIC_ASSETS_PATH: 'https://storage.googleapis.com/sfc-static',
  DOMAIN: 'flighttraveltrip.com',
  SUPPORT_PHONE: '+1 (833) 374-0139',
  SUPPORT_PHONE_IND: '+91 (124) 403-3968',
  CONTACT_EMAIL: 'admin@flighttraveltrip.com',
  MAP_ADDRESS: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.299695375939!2d77.06520908586566!3d28.500629627512705!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1900696bb517%3A0x58c6a73bac632635!2sSigma%20Tower!5e0!3m2!1sen!2sus!4v1746482477006!5m2!1sen!2sus',
  CALL_NOW_POPUP_HEADING_TEXT: 'Call now for Booking, Changes and Cancellation',
  CALL_NOW_POPUP_SAVE_PRICE: 1050,
  CALL_NOW_POPUP_SAME_PAGE_TIMEOUT_SEC: 1030,
  DISCLAIMER: `Flight Travel Trip is an independent travel booking platform owned by its parent company, Fare Destination Pvt Ltd. We are not affiliated with any airlines, and any airline names or references on our website are for informational purposes only. They do not indicate any partnership or endorsement. As a third-party service provider, our goal is to help customers find and book affordable flight options easily.`,
  GA_ID: '',
  PAGE_ID_TO_PHONE: {
    [PAGE_IDS.FLIGHT]: '+1 (833) 374-0139'
  },
  LOCALE: 'INR',
  LOCALE_SYMBOL: '₹',
};
export default Application;
